
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabRTRootProps = TemplateRootPropsForTag<'a'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabRT(): TemplateResult<fitmentTableTabRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('a', {
        'className': 'tab-title',
        'href': '#tab-fitments',
        'role': 'tab',
        'tabIndex': '0',
        'aria-selected': 'true',
        'controls': 'tab-fitments',
        'key': '0'
    }, '\n  Fitments\n') : null;
}
        export const componentNames = []